// extracted by mini-css-extract-plugin
export default {"LiveContentSection":"LiveContentSection_LiveContentSection__XAXYv"};